'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface Activity {
  id: number;
  type: 'booking' | 'project' | 'success';
  message: string;
  time: string;
  icon: string;
}

const LiveSocialValidation = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [visibleActivity, setVisibleActivity] = useState(0);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const activities: Activity[] = [
    {
      id: 1,
      type: 'booking',
      message: 'Sarah M. from TechVenture just booked a consultation',
      time: '2 minutes ago',
      icon: 'CalendarIcon'
    },
    {
      id: 2,
      type: 'project',
      message: 'New AI automation project completed for Global Innovations',
      time: '15 minutes ago',
      icon: 'CheckCircleIcon'
    },
    {
      id: 3,
      type: 'success',
      message: 'StartupBoost achieved 340% ROI increase',
      time: '1 hour ago',
      icon: 'ChartBarIcon'
    },
    {
      id: 4,
      type: 'booking',
      message: 'Michael C. from Enterprise Dynamics scheduled a demo',
      time: '2 hours ago',
      icon: 'CalendarIcon'
    },
    {
      id: 5,
      type: 'project',
      message: 'Marketing automation deployed for RetailPro',
      time: '3 hours ago',
      icon: 'RocketLaunchIcon'
    }
  ];

  useEffect(() => {
    if (!isHydrated) return;

    const interval = setInterval(() => {
      setVisibleActivity((prev) => (prev + 1) % activities.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isHydrated, activities.length]);

  const getActivityColor = (type: string) => {
    switch (type) {
      case 'booking':
        return 'bg-accent/10 text-accent border-accent/20';
      case 'project':
        return 'bg-success/10 text-success border-success/20';
      case 'success':
        return 'bg-brand-purple/10 text-brand-purple border-brand-purple/20';
      default:
        return 'bg-primary/10 text-primary border-primary/20';
    }
  };

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-success/10 px-4 py-2 rounded-full mb-4">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
            <span className="text-sm font-medium text-success">Live Activity Feed</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-display font-bold text-foreground">
            Real-Time Success Stories
          </h2>
        </div>

        {isHydrated && (
          <div className="max-w-4xl mx-auto">
            <div className="bg-card rounded-xl p-6 shadow-subtle border border-border min-h-[120px] flex items-center">
              <div className="w-full">
                <div className={`flex items-start space-x-4 p-4 rounded-lg border transition-all duration-500 ${getActivityColor(activities[visibleActivity].type)}`}>
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-current/10 flex items-center justify-center">
                    <Icon name={activities[visibleActivity].icon as any} size={20} />
                  </div>
                  <div className="flex-1">
                    <p className="font-medium text-foreground mb-1">
                      {activities[visibleActivity].message}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      {activities[visibleActivity].time}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mt-12">
              <div className="bg-card rounded-xl p-6 border border-border text-center">
                <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="UserGroupIcon" size={24} className="text-accent" />
                </div>
                <div className="text-3xl font-display font-bold text-foreground mb-2">47</div>
                <div className="text-sm text-muted-foreground">Active consultations this week</div>
              </div>

              <div className="bg-card rounded-xl p-6 border border-border text-center">
                <div className="w-12 h-12 rounded-full bg-success/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="CheckCircleIcon" size={24} className="text-success" />
                </div>
                <div className="text-3xl font-display font-bold text-foreground mb-2">23</div>
                <div className="text-sm text-muted-foreground">Projects completed this month</div>
              </div>

              <div className="bg-card rounded-xl p-6 border border-border text-center">
                <div className="w-12 h-12 rounded-full bg-brand-purple/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="ChartBarIcon" size={24} className="text-brand-purple" />
                </div>
                <div className="text-3xl font-display font-bold text-foreground mb-2">98%</div>
                <div className="text-sm text-muted-foreground">Client satisfaction rate</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default LiveSocialValidation;